import React from 'react'

/* eslint-disable import/no-cycle */

import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import errorImageMobile from 'assets/error-image-mobile.png'
import errorImageDesktop from 'assets/error-image.png'
import Button from 'components/button'
import { oops as e2eClasses } from 'constants/e2eClasses'
import GDS_MESSAGES from 'constants/gdsMessages'
import { generateHomeRoute } from 'helpers/url/localization'
import { isMobile } from 'helpers/utils'
import NAMESPACES from 'localization/constants/namespaces'
import { mapMediaType } from 'selectors/mediaType'

import {
  Wrapper,
  Image,
  TextWrapper,
  Title,
  SecondaryTitle,
  ErrorMessage,
  ButtonWrapper
} from './styled'

const INVALID_FLIGHT_ERROR = 'booking.error.invalid-flight-type'
const CONTAINS_CHECKED_COUPONS_ERROR = 'gds.booking.error.containsCheckedCoupons'
const DUPLICATE_LEG = 'shopping.search.legs.repeats'

class OopsError extends React.PureComponent {
  getErrorMessages = () => {
    const { error, showSingleMessage, t } = this.props

    const validation =
      error &&
      !showSingleMessage &&
      (!error.errorMessage === GDS_MESSAGES.VALIDATION_ERROR ||
        error.description[0] === INVALID_FLIGHT_ERROR ||
        error.description[0] === CONTAINS_CHECKED_COUPONS_ERROR)

    const duplicateLegValidation =
      error && showSingleMessage && error.description[0] == DUPLICATE_LEG

    if (validation || duplicateLegValidation) {
      const { description, errorMessage } = error

      if (description) {
        return [description]
      }

      if (errorMessage) {
        return [errorMessage]
      }
    }

    return [t('general.error-pages.purchase-error')]
  }

  goToHomePage = () => {
    this.props.history.replace(generateHomeRoute(this.props.i18n.language))
  }

  getImage = () => {
    const { image, imageMobile, mediaType } = this.props

    if (isMobile(mediaType)) {
      return imageMobile || errorImageMobile
    }

    return image || errorImageDesktop
  }

  render() {
    const {
      title,
      secondaryTitle,
      buttonText,
      buttonClick,
      secondaryButtonText,
      secondaryButtonClick,
      t,
      error
    } = this.props

    const exchangesEnabled = !(error?.description && error?.description[0] === INVALID_FLIGHT_ERROR)

    return (
      <Wrapper>
        <Image src={this.getImage()} alt="error" />
        <TextWrapper>
          <Title>{t(title || 'general.error-pages.oops')}</Title>
          <SecondaryTitle e2eClass={e2eClasses.subTitle}>
            {t(secondaryTitle || 'general.error-pages.we-are-sorry')}
          </SecondaryTitle>
          {this.getErrorMessages().map(error => (
            <ErrorMessage e2eClass={e2eClasses.message} key={error}>
              {t(error)}
            </ErrorMessage>
          ))}
          <ButtonWrapper fullWidth={!exchangesEnabled}>
            {exchangesEnabled && (
              <Button onClick={buttonClick || this.goToHomePage} small name={e2eClasses.button}>
                {t(buttonText || 'general.error-pages.go-to-home-page')}
              </Button>
            )}
            {secondaryButtonText && (
              <Button
                onClick={secondaryButtonClick}
                small
                gray={exchangesEnabled}
                name={e2eClasses.secondaryButton}
              >
                {t(secondaryButtonText)}
              </Button>
            )}
          </ButtonWrapper>
        </TextWrapper>
      </Wrapper>
    )
  }
}

const mapStateToProps = state => ({
  mediaType: mapMediaType(state)
})

export default withTranslation(NAMESPACES.EXCHANGES)(
  withRouter(connect(mapStateToProps)(OopsError))
)
